import { capitalize } from './capitalize';

export const throwNewErrorFromRes = (res) => {
  if (res?.data?.success === false) throw new Error(res?.data?.error_message || 'An unexpected error occured');
};

export const mapErrorsObject = (errObj) => {
  return Object.entries(errObj).map((entry) => `${capitalize(entry[0])} - ${entry[1]}`);
};
